import { useState, useEffect } from "react";
import {
  _get_all_state,
  _get_cities_by_state_code,
} from "../common/axios_services";
import { showErrorNotification } from "../common/utils/notification";

const useLocationData = (initialState = null, initialLga = null) => {
  const [allStates, setAllStates] = useState([]);
  const [selectedState, setSelectedState] = useState(initialState);
  const [allLgas, setAllLgas] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingLgas, setLoadingLgas] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStates = async () => {
      setLoadingStates(true);
      try {
        const response = await _get_all_state();
        setAllStates(response.data.data);
      } catch (err) {
        setError(err);
        showErrorNotification(err.message || "Failed to fetch states", "Error");
      } finally {
        setLoadingStates(false);
      }
    };
    fetchStates();
  }, []);

  useEffect(() => {
    if (selectedState) {
      const fetchLgas = async () => {
        setLoadingLgas(true);
        try {
          const response = await _get_cities_by_state_code(selectedState);
          setAllLgas(response.data.data);
        } catch (err) {
          setError(err);
          showErrorNotification(err.message || "Failed to fetch LGAs", "Error");
        } finally {
          setLoadingLgas(false);
        }
      };
      fetchLgas();
    } else {
      setAllLgas([]);
    }
  }, [selectedState]);

  return {
    allStates,
    selectedState,
    setSelectedState,
    allLgas,
    loadingStates,
    loadingLgas,
    error,
  };
};

export default useLocationData;
